<template>
  <q-item v-bind="$attrs" @click="viewClientProfile">
    <q-item-section>
      <q-item-label>
        <strong>{{ userName }}</strong>
        Facebook account connected.
      </q-item-label>
      <q-item-label caption>
        <slot></slot>
      </q-item-label>
    </q-item-section>
  </q-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface FacebookAccountAuthenticated {
  id: number,
  client: {
    id: number,
    firstName: string,
    lastName: string,
  },
  socialSite: {
    id: number,
    type: string,
    name: string,
  }
}

export default defineComponent({
  props: {
    data: {
      type: Object as () => FacebookAccountAuthenticated,
      required: true,
    },
  },
  computed: {
    userName(): string {
      return `${this.data.client.lastName}, ${this.data.client.firstName}`;
    },
  },
  methods: {
    viewClientProfile() {
      this.$router.push(`/clients/${this.data.client.id}`);
    },
  },
});
</script>
